import { IServicesState } from '../../types/services';
import { TReduxActions } from '../../types/redux/actions';
import { EServicesActions } from '../../constants/actionTypes/services';

export const defaultState: IServicesState = {
  data: [],
};

export function servicesReducer(state: IServicesState = defaultState, action: TReduxActions) {
  switch (action.type) {
    case EServicesActions.SET_SERVICES:
      return {
        ...state,
        data: action.payload,
      };

    default:
      return state;
  }
}
